import { render } from "./detail.vue?vue&type=template&id=52881a99&scoped=true&ts=true"
import script from "./detail.vue?vue&type=script&lang=tsx"
export * from "./detail.vue?vue&type=script&lang=tsx"

import "./detail.vue?vue&type=style&index=0&id=52881a99&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52881a99"]])

export default __exports__